export const grid = {
  columns: 12,
  gutter: 20,
  maxWidth: {
    md: "100%",
    lg: "1440px",
  },
};
